<template>
  <div class="shop">
    <div class="list">
      <template v-for="(item, i) in list">
        <div class="item" :key="i">
          <template v-if="item.url">
            <a :href="item.url" target="_blank">
              <div class="img hover-border">
                <img :src="`/${options.cdn}/${item.image}`"/>
              </div>
            </a>
          </template>
          <template v-else>
            <div class="img hover-border">
              <img :src="`/${options.cdn}/${item.image}`"/>
            </div>
          </template>
          <div class="content">
            <div class="name-and-html">
              <div class="name">
                <template v-if="item.url">
                  <a class="italic-font" :href="item.url" target="_blank">{{item.title}}</a>
                </template>
                <template v-else>
                  <span class="italic-font">{{item.title}}</span>
                </template>
              </div>
              <div class="html" v-html="item.desc"></div>
            </div>
            <div class="code-img" v-if="item.codeImg">
              <img :src="`/${options.cdn}/${item.codeImg}`" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'shop',
    data() {
      return {
        list: []
      }
    },
    computed: {
      ...mapState(['options'])
    },
    async mounted() {
      this.list = await this.axios.get('/shop')
    }
  }
</script>

<style lang="stylus" scoped>
  .shop
    padding 0 20px

    .list
      column-gap 20px
      column-count 2
      margin 0 auto

      .item
        display block
        break-inside avoid
        margin-bottom 30px

        a
          cursor pointer

        .content
          margin-top 20px
          display flex
          align-items flex-start

          .name-and-html
            display flex
            flex-direction column

          .name
            font-size 2.6rem
            margin-bottom 20px

          .html
            >>> p
              line-height 1.4

          .code-img
            margin-left 30px
            width 300px
            img
              width 100%



        img
          width 100%

  @media screen and (max-width: 768px)
    .shop
      .list
        column-count 1
</style>
